module.exports = __webpack_public_path__ + "img/successInfo-2.be95bce0.png";